import { Clock } from 'lucide-react';
import type { DaySchedule, StoreStatus } from './contactHours';

interface OpeningHoursWeekProps {
  schedules: DaySchedule[];
  status: StoreStatus;
}

export function OpeningHoursWeek({ schedules, status }: OpeningHoursWeekProps) {
  return (
    <div className="wl6-hours-panel">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
        <div className="flex items-center gap-3">
          <div className="wl6-trust-icon shrink-0" style={{ backgroundColor: 'var(--wl6-accent-bg)' }}>
            <Clock className="h-5 w-5" style={{ color: 'var(--wl6-accent)' }} />
          </div>
          <div>
            <h3 className="font-semibold text-[var(--wl6-text)]">Horários</h3>
            <p className="text-sm text-[var(--wl6-muted)]">{status.detail}</p>
          </div>
        </div>
        <div className={`wl6-hours-status shrink-0 ${status.isOpen ? 'wl6-hours-status--open' : 'wl6-hours-status--closed'}`}>
          <span className="wl6-hours-status-dot" aria-hidden="true" />
          {status.label}
        </div>
      </div>

      <div className="wl6-hours-week" role="list" aria-label="Horários por dia">
        {schedules.map((schedule) => (
          <div
            key={schedule.key}
            role="listitem"
            className={`wl6-hours-week-day ${schedule.isToday ? 'wl6-hours-week-day--today' : ''}`}
            aria-current={schedule.isToday ? 'date' : undefined}
          >
            <span className="wl6-hours-week-day-label">{schedule.short}</span>
            {schedule.isToday && status.isOpen && (
              <span className="wl6-hours-week-live">
                <span className="wl6-hours-week-live-dot" aria-hidden="true" />
                Aberto
              </span>
            )}
            {schedule.isToday && !status.isOpen && (
              <span className="wl6-hours-week-day-label wl6-hours-week-day-label--today">Hoje</span>
            )}
            <span className="wl6-hours-week-day-name">{schedule.label}</span>
            <span className={`wl6-hours-week-day-time ${schedule.isClosed ? 'is-closed' : ''}`}>
              {schedule.hours}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
